import React from 'react'

// STYLES /
import './stylesMovieCard.scss'
import Custombutton from '../Custombutton/Custombutton'

function MovieCard({title, category, imageSrc, overview, actionButton ,vote_average, id, streamInfos, buyInfos}) {

  const IMG_PATH= "https://image.tmdb.org/t/p/original"

  return (
    <div className='movieCard'>

        {/* <h1 className='movieCard_description'> MOVIE id is : {id }</h1> */}

        {title ?
          <h2 className='movieCard_title'>{title}</h2>
        : <p> Aucune film trouvé </p>
        }

        {imageSrc ?
          <img className='movieCard_image' src={ `${IMG_PATH}${imageSrc}`} alt='moviePoster' />
        : null
        }


        {category ?
          <p className='movieCard_catégorie'>{category}</p>
        : null
        }

        {vote_average ?
        <div className='movieCard_vote_container'>
              <p className='movieCard_vote_container_text'>{vote_average}/10</p>
        </div>
              :
            null
            }

        {overview ?
          <p className='movieCard_description'>{overview}</p>
          :
          <p className='movieCard_description'>Pas de résumé pour ce film</p>
          }
        
        {/* <div className='movieCard_streamInfos'>           
        
        {streamInfos}
        
        </div>

        <div className='movieCard_buyInfos'>           
        

        {buyInfos}
        
        </div> */}
        
     



          <div className='movieCard_button'>
              <Custombutton
                action={actionButton}
                text={'Film suivant !'} 
              />
          </div>
    </div>
  )
}

export default MovieCard
